export enum SolarPanelType {
  Unknown = 0,
  Classic = 1,
  Black = 2,
  HighPerformance = 3,
}

export enum RoofType {
  Unknown = 0,
  FlatRoof = 1,
  Slate = 2, // Ardoise
  Tile = 3, // Tuile
  MetalSheet = 4, // metal
}

export enum InverterType { // (Sauf erreur de ma part c'est SMA bas de game et solar edge haut de gamme)
  Unknown = 0,
  SMA = 1,
  SolarEdge = 2,
}

export enum NetworkType {
  Unknown = 0,
  Mono = 1,
  Tri = 2,
  Tri3N400 = 3,
}

export enum Orientation {
  Unknown = 0,
  Portrait = 1,
  Landscape = 2,
}

export enum ReductionType {
  None = 0,
  Percent = 1,
  PricePerWhC = 2,
}
